module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gvMqq"))).then(() => parcelRequire('1iHdE'));